module.exports = __webpack_public_path__ + "static/media/p2.8edb2135.jpg";